export enum TaskBallColor {
  Silver = 0,
  Red = 1,
  Purple = 2,
  Blue = 3,
}
